import { PropChallenge, PropChallengeChallengeTypeEnum } from 'services/generatedClientFromSwagger';

/**
 * Determines if a challenge requires the activation dialog flow (KYC and/or terms & conditions).
 * - ALL Funded challenges require the dialog (for terms & conditions), regardless of requireKyc
 * - Audition challenges only require the dialog if requireKyc is true
 * - Returns false if terms and conditions have already been accepted
 */
export const doesChallengeRequireActivationFlow = (challenge?: PropChallenge): boolean => {
    if (!challenge) {
        return false;
    }

    // If terms and conditions are already accepted, no activation flow is needed
    if (challenge.acceptTermsAndConditions) {
        return false;
    }

    // All funded challenges require the activation flow (for terms & conditions)
    if (challenge.challengeType === PropChallengeChallengeTypeEnum.Funded) {
        return true;
    }

    // Audition challenges only require the flow if they need KYC
    if (challenge.challengeType === PropChallengeChallengeTypeEnum.Audition && challenge.requireKyc) {
        return true;
    }

    return false;
};
